<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LPO_REASON = 'get_lpo_reason.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoReason',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`lpo_reason`, this.selected)
			}
		},
		created: function () {
			fetch(DB + LPO_REASON, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = data[0].id
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// lpoReason.vue?afcb4c68